import { useEffect, useState } from "react";

// Returns `value`, but only updates after `delayMs` of no further changes —
// use for search/filter inputs that currently fire an API call on every
// keystroke (e.g. the header typeahead, admin team search).
const useDebouncedValue = (value, delayMs = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
